import { api } from '../axios'
import type { ApiResponse } from '../../../types'

export const cascadeApi = {
  // Get cascade information
  getSchoolCascadeInfo: (schoolId: string) =>
    api.get<ApiResponse<{
      schoolId: string;
      cascadeInfo: {
        teachers: number;
        medicalRecords: number;
        attachments: number;
        deputations: number;
        postingHistories: number;
      };
      totalAffected: number;
      warning: string;
    }>>(`/cascade/school/${schoolId}`),

  getTeacherCascadeInfo: (teacherId: number) =>
    api.get<ApiResponse<{
      teacherId: number;
      cascadeInfo: {
        medicalRecords: number;
        attachments: number;
        deputations: number;
        postingHistories: number;
      };
      totalAffected: number;
      warning: string;
    }>>(`/cascade/teacher/${teacherId}`),

  getUserCascadeInfo: (userId: number) =>
    api.get<ApiResponse<{
      userId: number;
      cascadeInfo: {
        refreshTokens: number;
        medicalRecordsEntered: number;
        auditLogs: number;
      };
      totalAffected: number;
      canDelete: boolean;
      warning: string;
    }>>(`/cascade/user/${userId}`),

  // Safe delete operations
  safeDeleteSchool: (schoolId: string, force: boolean = false) =>
    api.delete<ApiResponse<any>>(`/cascade/school/${schoolId}?force=${force}`),

  safeDeleteTeacher: (teacherId: number, force: boolean = false) =>
    api.delete<ApiResponse<any>>(`/cascade/teacher/${teacherId}?force=${force}`),

  safeDeleteUser: (userId: number, force: boolean = false) =>
    api.delete<ApiResponse<any>>(`/cascade/user/${userId}?force=${force}`),
}

export const templatePresetApi = {
  async list() {
    const response = await api.get('/template-presets')
    return response.data?.data as any[]
  },

  async save(payload: { id?: number; name: string; content: string; visibility?: 'PERSONAL' | 'DIRECTORATE' | 'SECRETARIAT' | 'GLOBAL'; adminScope?: 'DIRECTORATE' | 'SECRETARIAT' | null }) {
    const response = await api.post('/template-presets', payload)
    return response.data?.data as any
  },

  async remove(id: number) {
    return api.delete(`/template-presets/${id}`)
  }
}

export const priorityBadgesApi = {
  getByTeacherId: (teacherId: number) =>
    api.get(`/priority-badges/teacher/${teacherId}`),

  request: (data: FormData) =>
    api.post('/priority-badges/request', data),

  getPending: () =>
    api.get('/priority-badges/pending'),

  // Get count of pending priority badges
  getPendingCount: () =>
    api.get<ApiResponse<any[]> & { pagination?: { total: number } }>('/priority-badges/pending?page=1&limit=1'),

  approve: (id: number, data: any) =>
    api.put(`/priority-badges/${id}/approve`, data),

  reject: (id: number, data: any) =>
    api.put(`/priority-badges/${id}/reject`, data),

  expire: () =>
    api.post('/priority-badges/expire'),
}

